export default "__VITE_ASSET__DABm4xnZ__"